import React from 'react';
import LPChapterItem from './LPChapterItem';
// import { LPElement } from '../../types/LPElement';

interface LPChapterListProps {
    chapters: any; //LPElement[];
    offset: number;
}

const LPChapterList: React.FC<LPChapterListProps> = ({ chapters, offset }) => {
    return (
        <div className="mt-4">
            {chapters?.map(
                (chapter: any, index: number) =>
                    chapter?.name && (
                        <div key={index}>
                            <LPChapterItem chapter={chapter} offset={offset} />
                            {index !== chapters?.length - 1 && (
                                <hr className="border-gray-400  border-1 opacity-50 border-dashed" />
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default LPChapterList;
